// removed by extract-text-webpack-plugin
module.exports = {"Page":"_1SciqAyTX-FhsIKyg_WEqL","TitleBar":"_3HlUIJ6_Lym8Fy7Vh4HMiD","RightControls":"Agkj96zwKbWV87PnvLPSM"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Reports/Break/index.css
// module id = 944
// module chunks = 0